import React from 'react';
import { BookOpenIcon, GiftIcon, PickaxeIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: PickaxeIcon,
  label: '+450 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and educators'
}];
export function SocialProof() {
  return <section className="border-y border-gold/50 bg-steel py-5" aria-label="What the teacher ready includes" data-id="element-233" data-mp="3f4wsm8gmzlg">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-white sm:justify-between" data-id="element-234" data-mp="8ehgiy41bqjt">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-235" data-mp="3usr2z1oemohy">
            <Icon className="h-5 w-5 text-mineral" aria-hidden="true" data-id="element-236" data-mp="mdzb5u40hy13" /> {label}
          </span>)}
      </div>
    </section>;
}